import { ErrorMessage, Field, FieldArray, useFormikContext } from 'formik';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProposedActivityComponent from './ProposedActivityDetails';
import { CONSTANT_DATA_FIELD } from '../../../../utils/constants';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import { APPLICANT_DETAILS_I } from './Allotment.const';
import GenericOwnerShipDetails from '../../../../components/Ownership/GenericOwnership';
import { tooltipDetails } from './ApplicantDetails';
import { getAdditionalDetailsForm, getAdditionalDetailsFormII, getType } from '../EstateManagement.controller';
import { ADDITIONAL_DETAILS_FORM, ADDITIONAL_DETAILS_FORM_II } from '../Payment/EstatePayment.const';
import _ from 'lodash';
import { BankDetailReadOnly, ExistingBlokAndFloorDetailsReadOnly, ExistingMortgageReadOnly, NOCReadOnly, OwnershipReadOnly, ProposedActivityReadOnly } from './ReadOnlyTables';
import { SURRENDER_EXISTING_MORTGAGE_DETAILS } from '../Surrender/Surrender.const';
import { trash } from '../../../../utils/Logo';
import { bankDetailsInitialValue, EMAIL_ID_FINANCIAL_INST_TOOLTIP, MORTGAGE_CHANGES_FINANCIAL_DETAILS, MORTGAGE_EXISTING_MORTGAGE_DETAILS } from '../../Mortgage Lessee/Mortgage.const';
import GenericFileUploadField from '../../../../components/moduleCommonFormik/GenericFileUpload.component';
import ToolTipDetails from '../../../../components/ToolTipFile';
import GenericEmailIDNotification from '../../../../components/moduleCommonFormik/GenericEmailIDNotification.component';
import GenericCommonTextField from '../../../../components/moduleCommonFormik/GenericCommonTextField.component';
import BpaCommonSelector from '../../../../components/moduleCommonFormik/BpaCommonSelector.component';
import DeleteIconFloor from '../../../../assets/logos/deleteButton.svg';
import { FLOOR_TYPES } from '../../../orderCompletionScreen/OrderCompletionFormPage.module';

export const AdditionalDetails = (props: any) => {
    const { t } = useTranslation();
    const { values, setFieldValue, setValues } = useFormikContext<any>();

    const [tableType, setTableType] = useState<any>([]);
    const [formData, setFormData] = useState<any>([{ formData: [] }]);
    const [finalOwnerShipDetails, setFinalOwnerShipDetails] = useState({
        applicantDetails: []
    });

    useEffect(() => {
        let form: any = [];
        props.data?.map((item: any) => {
            if (item?.type === 'TABLE_DATA') {
                setTableType([...tableType, item.code]);
            } else {
                form = [
                    ...form,
                    {
                        title: item?.description,
                        field: item.code,
                        type: getType(item?.type),
                        isRequired: true,
                        isDisabled: item?.status === 'CLOSED' ? true : false,
                        status: item.status,
                        multiSelect: item?.type === 'MULTI_DROPDOWN' ? true : undefined,
                        enableFutureDate: true,
                        options:
                            item.type === 'RADIO'
                                ? [
                                      { value: true, title: 'Yes' },
                                      { value: false, title: 'No' }
                                  ]
                                : undefined
                    }
                ];
            }
        });
        setFormData(form);
        const pendingItem = props?.data?.length && props?.data?.filter((val: any) => val?.status === 'PENDING');
        pendingItem?.length > 0 && setFieldValue('isUpdatable', true);

        return () => {
            setFieldValue('isUpdatable', false);
        };
    }, []);

    console.log('formData', formData);

    const onOwnershipDetailsChange = (key: string, value: any) => {
        setFinalOwnerShipDetails({ ...finalOwnerShipDetails, [key]: value });
    };

    const renderProposedActivity = (code: string, status: string) => {
        return <ProposedActivityComponent isDisabled={false} nicDetails={props.nicDetails} setNicDetails={props.setNicDetails} showPopUp={props?.showPopUp} setShowPopUp={props?.setShowPopUp} />;
    };

    const renderOwnership = (code: string, status: string) => {
        return (
            <GenericOwnerShipDetails
                showOwnershipModal={props.showOwnershipModal}
                setShowOwnershipModal={props.setShowOwnershipModal}
                changeOwnershipDetails={(values: any) => onOwnershipDetailsChange('applicantDetails', values)}
                values={values}
                dropdownData={props?.dropdownData}
                setControllingOwnershipResponse={props?.setControllingOwnershipResponse}
                controllingOwnershipResponse={props?.controllingOwnershipResponse}
                allOwnerShipDetails={finalOwnerShipDetails}
                setOwnershipDetails={props?.setOwnershipDetails}
                setCalculated={props?.setCalculated}
                ownershipDetails={props?.ownershipDetails}
                toolTipDetails={tooltipDetails}
                isDisabled={status === 'CLOSED'}
                hideCard={true}
                scrollNotRequired={props.scrollNotRequired}
                skipFullOwnershipPercent={props?.skipFullOwnershipPercent}
                isWorkflow={props.isWorkflow}
            />
        );
    };

    const renderNoc = () => {
        return (
            <>
                {!!values.financingObtained && values.existingMortgageDetails.length && (
                    <form>
                        <FieldArray name='existingMortgageDetails'>
                            {({}) => (
                                <div>
                                    {values.existingMortgageDetails?.length > 0 &&
                                        values.existingMortgageDetails.map((data: any, index_p: number) => (
                                            <div className='row' key={index_p}>
                                                <div className='col-sm-12  align-items-center pb-2'>
                                                    <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                                    <div className='ps-1'>
                                                        {SURRENDER_EXISTING_MORTGAGE_DETAILS.map((val: any, _: number) => (
                                                            <GenericFormCard fieldPath={`existingMortgageDetails.${index_p}`} {...val} />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            )}
                        </FieldArray>
                    </form>
                )}
            </>
        );
    };

    const renderCurrentBankDetails = () => {
        const handleEmailValues = (email: any, index: number) => {
            setValues((prevVal: any) => ({
                ...prevVal,
                bankDetails: prevVal?.bankDetails?.map((item: any, ind: number) => {
                    if (ind === index) {
                        return { ...item, notificationEmails: email };
                    } else {
                        return { ...item };
                    }
                })
            }));
        };

        return (
            <form>
                <FieldArray name='bankDetails'>
                    {({ remove, push }) => (
                        <div>
                            {values.bankDetails?.length > 0 &&
                                values.bankDetails.map((data: any, bank_index: number) => (
                                    <div className='row' key={bank_index}>
                                        <div className='col-sm-12 align-items-center pb-2'>
                                            <div className='formHeading'>{`Financial Institution/Bank - ${bank_index + 1}`}</div>
                                            <div className=' ps-1'>
                                                {bank_index !== 0 && (
                                                    <div className='d-flex justify-content-end  mx-3'>
                                                        <img
                                                            style={{ cursor: 'pointer', zIndex: 1, background: '#45852E1F', padding: '6px', height: '35px', borderRadius: '6px' }}
                                                            onClick={() => remove(bank_index)}
                                                            src={trash}
                                                            alt='delete'
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <div className='row d-flex m-0'>
                                                {MORTGAGE_CHANGES_FINANCIAL_DETAILS[0]?.formData.map((formField: any, id: number) => (
                                                    <div className={`py-3 col-sm-6`} key={id}>
                                                        <label htmlFor={`bankDetails.${bank_index}.${formField.field}`} className='pb-2 file-form-label'>
                                                            {formField.title} - {bank_index + 1}
                                                            {formField.isRequired && <span className='mandatory-indicator'> *</span>}
                                                        </label>

                                                        <Field
                                                            name={`bankDetails.${bank_index}.${formField.field}`}
                                                            type={'text'}
                                                            id={`bankDetails.${bank_index}.${formField.field}`}
                                                            className={` form-control was-validated`}
                                                            onChange={(e: any) => {
                                                                const newValue =
                                                                    formField.type === 'number'
                                                                        ? parseInt(e.target.value)
                                                                        : formField.field === 'bankIFSC'
                                                                          ? e.target.value.toUpperCase()
                                                                          : e.target.value;
                                                                setFieldValue(`bankDetails.${bank_index}.${formField.field}`, newValue);
                                                                formField.field === 'bankIFSC' && props.handleSearchIFSCMortgage(newValue, bank_index);
                                                            }}
                                                            value={_.get(values, `bankDetails.${bank_index}.${formField.field}`)}
                                                        />
                                                        <ErrorMessage name={`bankDetails.${bank_index}.${formField.field}`}>{msg => <span className='text-danger font-12'>{msg}</span>}</ErrorMessage>
                                                    </div>
                                                ))}
                                                <div className='col-6 py-3'>
                                                    <GenericFileUploadField
                                                        field={`bankDetails.${bank_index}.bankLetter`}
                                                        title={`Bank Letter`}
                                                        entityFileData={{ documentNamePrefix: `${_.get(values, `bankDetails.${[bank_index]}.bankName`)}_Bank Letter `, documentType: '' }}
                                                        isRequired={true}
                                                    />
                                                </div>

                                                <div className='px-3'>
                                                    <div className='formTitle d-flex align-items-center'>
                                                        {t('EMAIL_ID_OF_FIN_INST', 'Email id of Financial Institution')}
                                                        <ToolTipDetails toolTipDetails={EMAIL_ID_FINANCIAL_INST_TOOLTIP} />
                                                    </div>

                                                    <GenericEmailIDNotification
                                                        isEditable={true}
                                                        emailIdsData={values?.bankDetails?.[bank_index]?.notificationEmails}
                                                        getEmailIds={email => handleEmailValues(email, bank_index)}
                                                        // errors={errorIndex === bank_index ? notificationError : null}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            <div className='mx-3'>
                                <button className='col-sm-12 mt-2 mb-4  justify-content-center align-items-center noc_add_fields' type='button' onClick={() => push(bankDetailsInitialValue)}>
                                    + Add Bank
                                </button>
                            </div>
                        </div>
                    )}
                </FieldArray>
            </form>
        );
    };

    const renderExistingMortgageDetails = () => {
        const handleEmailValues = (email: any, index: number) => {
            setValues((prevVal: any) => ({
                ...prevVal,
                bankDetails: prevVal?.bankDetails?.map((item: any, ind: number) => {
                    if (ind === index) {
                        return { ...item, notificationEmails: email };
                    } else {
                        return { ...item };
                    }
                })
            }));
        };
        return (
            <form>
                <FieldArray name='existingMortgageDetails'>
                    {({}) => (
                        <div>
                            {values.existingMortgageDetails?.length > 0 &&
                                values.existingMortgageDetails.map((data: any, index_p: number) => (
                                    <div className='row' key={index_p}>
                                        <div className='col-sm-12  align-items-center pb-2'>
                                            <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                            <div className=' ps-1'>
                                                {MORTGAGE_EXISTING_MORTGAGE_DETAILS.map((val: any, _: number) => (
                                                    <GenericFormCard fieldPath={`existingMortgageDetails.${index_p}`} {...val} />
                                                ))}
                                                {values?.existingMortgageDetails?.[index_p]?.notificationEmails?.length > 0 ? (
                                                    <div className='px-3'>
                                                        <div className='formTitle'>{t('EMAIL_ID_OF_FIN_INST', 'Email id of Financial Institution')}</div>
                                                        <GenericEmailIDNotification
                                                            isEditable={false}
                                                            emailIdsData={values?.existingMortgageDetails?.[index_p]?.notificationEmails}
                                                            getEmailIds={email => handleEmailValues(email, index_p)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}
                </FieldArray>
            </form>
        );
    };

    const renderBlockFllorDetails = () => {
        return (
            <Form>
                <FieldArray name='blocks'>
                    {({ push, remove }) => (
                        <>
                            {!!values?.blocks &&
                                !!values?.blocks.length &&
                                values?.blocks.map((block: any, blockIndex: any) => (
                                    <div className='my-3'>
                                        <div key={blockIndex}>
                                            <div className='d-flex'>
                                                <span className='font-inter' style={{ fontWeight: 600, fontSize: '22px', lineHeight: '32px', color: '#3a7425', marginLeft: '10px' }}>
                                                    Block - {blockIndex + 1}
                                                </span>
                                                <div className='d-flex justify-content-end mt-1' style={{ position: 'absolute', right: '2%' }}>
                                                    {blockIndex !== 0 && (
                                                        <img className='' style={{ cursor: 'pointer', zIndex: 100 }} src={DeleteIconFloor} onClick={() => remove(blockIndex)} alt='delete' />
                                                    )}
                                                </div>
                                            </div>
                                            <FieldArray name={`blocks.${blockIndex}.floors`}>
                                                {({ push, remove }) => (
                                                    <>
                                                        {block.floors.map((floor: any, floorIndex: any) => (
                                                            <div className='mt-3'>
                                                                <div key={floorIndex}>
                                                                    <div className='d-flex'>
                                                                        <span className='font-inter' style={{ fontWeight: 600, fontSize: '16px', lineHeight: '25.6px', marginLeft: '10px' }}>
                                                                            Floor - {floorIndex + 1}
                                                                        </span>
                                                                        <div className='d-flex justify-content-end' style={{ position: 'absolute', right: '2%' }}>
                                                                            {floorIndex !== 0 && (
                                                                                <img
                                                                                    className=''
                                                                                    style={{ cursor: 'pointer', zIndex: 100 }}
                                                                                    src={DeleteIconFloor}
                                                                                    onClick={() => remove(floorIndex)}
                                                                                    alt='delete'
                                                                                />
                                                                                // </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex justify-content-between mt-2'>
                                                                        <div className='col-sm-3 px-2 py-3'>
                                                                            <BpaCommonSelector
                                                                                title={t('OC_FLOOR_TYPE', 'Floor Type')}
                                                                                options={FLOOR_TYPES}
                                                                                isRequired={true}
                                                                                field={`blocks.${blockIndex}.floors.${floorIndex}.floorType`}
                                                                            />
                                                                        </div>
                                                                        <div className='col-sm-3 px-2 py-3'>
                                                                            <GenericCommonTextField
                                                                                title={t('OC_FLOOR_NUMBER', 'Floor Number')}
                                                                                isRequired={true}
                                                                                field={`blocks.${blockIndex}.floors.${floorIndex}.floorNumber`}
                                                                                type={'number'}
                                                                            />
                                                                        </div>
                                                                        <div className='col-sm-3 px-2 py-3'>
                                                                            <GenericCommonTextField
                                                                                title={t('OC_FLOOR_AREA', 'Floor Area')}
                                                                                // isRequired={true}
                                                                                field={`blocks.${blockIndex}.floors.${floorIndex}.floorArea`}
                                                                                type={'number'}
                                                                            />
                                                                        </div>
                                                                        <div className='col-sm-3 px-2 py-3'>
                                                                            <>
                                                                                <GenericCommonTextField
                                                                                    title={t('OC_BUILT_UP_AREA', 'Built Up Area')}
                                                                                    field={`blocks.${blockIndex}.floors.${floorIndex}.builtUpArea`}
                                                                                    isRequired={true}
                                                                                    type={'number'}
                                                                                />
                                                                            </>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}

                                                        <div className=''>
                                                            <button
                                                                className='col-sm-12 mt-2  mb-2 d-flex justify-content-center align-items-center noc_add_fields'
                                                                type='button'
                                                                onClick={() => push({ floorType: '', floorNumber: '', floorArea: '', builtUpArea: '' })}
                                                            >
                                                                + Add Floor
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </FieldArray>
                                        </div>
                                    </div>
                                ))}
                            <hr></hr>

                            <button
                                className='col-sm-12 mt-2  mb-4 d-flex justify-content-center align-items-center add_fields'
                                type='button'
                                onClick={() => push({ floors: [{ floorType: '', floorNumber: '', floorArea: '', builtUpArea: '' }] })}
                            >
                                + Add Block
                            </button>
                        </>
                    )}
                </FieldArray>
            </Form>
        );
    };

    return (
        <Card className='card_border font-inter'>
            <Card.Body>
                <div className='ps-2 py-2'>
                    {values.additionalDetails?.map((data: any, index: number) => (
                        <div className='row mx-1' key={index} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', borderRadius: '25px', position: 'relative', marginTop: '1rem' }}>
                            <div className='col-sm-12 align-items-center pb-2'>
                                <div className='ps-1'>
                                    {getAdditionalDetailsForm(ADDITIONAL_DETAILS_FORM, data.status).map((val: any, valIndex: number) => (
                                        <GenericFormCard key={`generic-card-${index}-${valIndex}-${val.code}`} fieldPath={`additionalDetails.${index}`} {...val} />
                                    ))}

                                    <>
                                        {data.type !== 'TABLE_DATA' ? (
                                            <GenericFormCard
                                                key={`dropdown-${index}`}
                                                fieldPath={`additionalDetails.${index}`}
                                                formData={[formData.find((item: any) => item.field === data.code && item.status === data.status)]}
                                                dropdownOptions={props.dropdownData}
                                            />
                                        ) : (data.code === 'ENTERPRISE_NIC_PROPOSED_ACTIVITY' || data.code === 'NIC_PROPOSED_ACTIVITY') && data.status === 'PENDING' ? (
                                            renderProposedActivity(data.code, data.status)
                                        ) : (data.code === 'APPLICANT_OWNER' || data.code === 'OWNER_CHANGE_DATA') && data.status === 'PENDING' ? (
                                            renderOwnership(data.code, data.status)
                                        ) : (data.code === 'ENTERPRISE_NIC_PROPOSED_ACTIVITY' || data.code === 'NIC_PROPOSED_ACTIVITY') && data.status === 'CLOSED' ? (
                                            <ProposedActivityReadOnly index={index} />
                                        ) : (data.code === 'APPLICANT_OWNER' || data.code === 'OWNER_CHANGE_DATA') && data.status === 'CLOSED' ? (
                                            <OwnershipReadOnly index={index} dropdownData={props.dropdownData} />
                                        ) : data.code === 'NOC_FROM_BANK' && data.status === 'PENDING' ? (
                                            renderNoc()
                                        ) : data.code === 'NOC_FROM_BANK' && data.status === 'CLOSED' ? (
                                            <NOCReadOnly index={index} />
                                        ) : data.code === 'CURRENT_BANK_DETAILS' && data.status === 'PENDING' ? (
                                            renderCurrentBankDetails()
                                        ) : data.code === 'CURRENT_BANK_DETAILS' && data.status === 'CLOSED' ? (
                                            <BankDetailReadOnly index={index} />
                                        ) : data.code === 'EXISTING_MORTGAGE_DETAILS' && data.status === 'PENDING' ? (
                                            renderExistingMortgageDetails()
                                        ) : data.code === 'EXISTING_MORTGAGE_DETAILS' && data.status === 'CLOSED' ? (
                                            <ExistingMortgageReadOnly index={index} />
                                        ) : data.code === 'BPA_BLOCK_FLOOR_DATA' && data.status === 'PENDING' ? (
                                            renderBlockFllorDetails()
                                        ) : data?.code === 'BPA_BLOCK_FLOOR_DATA' && data?.status === 'CLOSED' ? (
                                            <ExistingBlokAndFloorDetailsReadOnly floorData={{ blocks: data?.response }} />
                                        ) : (
                                            <></>
                                        )}
                                    </>

                                    {getAdditionalDetailsFormII(ADDITIONAL_DETAILS_FORM_II, data.status).map((val: any, key: number) => (
                                        <GenericFormCard {...val} fieldPath={`additionalDetails.${index}`} key={key} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};
